import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { buildLink } from "common/routing";
import { AuthContext } from "../Authorization/AuthContext";
import { StyledLink } from "../Common/__styles__/Typography";
export const GetHelpLink = ({
  propertyId,
}: {
  propertyId?: string;
  text?: string;
}) => {
  const { t } = useTranslation();
  const account = useContext(AuthContext).account!;
  return (
    <StyledLink
      href={buildLink("getHelp", { accountId: account.id }, { propertyId })}
    >
      {t("common-request-help")}
    </StyledLink>
  );
};
